module.exports = __webpack_public_path__ + "img/save-primary.0de07443.svg";